import React, { useState, useEffect } from "react";
import "./Store.scss";
import { useStoreState, useStoreActions } from "easy-peasy";
import { YMaps, Map, Placemark } from "react-yandex-maps";
import Checkbox from "../../components/Checkbox/Checkbox";
import { getAddress } from "../../utils/helper";
const mainClass = "storeMain";
let map;
const placeMarks = {};

const Card = ({ elem, index }) => {
  const hoverIndex = useStoreState((state) => state.something.hoverIndex);
  const setHoverIndex = useStoreActions(
    (actions) => actions.something.setHoverIndex
  );
  return (
    <div
      className={`${mainClass}-card ${
        hoverIndex == index ? `${mainClass}-active` : ""
      }`}
      onMouseEnter={() => {
        setHoverIndex(index);
        placeMarks[index].hint.open();
      }}
      onClick={() => {
        map.setCenter(getCoord(elem.map));
        placeMarks[index].balloon.open();
      }}
      onMouseLeave={() => {
        setHoverIndex(null);
        placeMarks[index].hint.close();
      }}
    >
      <div className={mainClass + "-cardAddress"}>{getAddress(elem.map)}</div>
      <div className={mainClass + "-phone"}>{elem.phone}</div>
      <div className={mainClass + "-schedule"}>{elem.schedule}</div>
    </div>
  );
};

function getCoord(str) {
  const arr = str.split("&");
  arr.pop();
  return arr;
}

const Marks = ({ stores }) => {
  const hoverIndex = useStoreState((state) => state.something.hoverIndex);
  const setHoverIndex = useStoreActions(
    (actions) => actions.something.setHoverIndex
  );
  return (
    <>
      {stores.map((el, index) => (
        <Placemark
          onMouseEnter={() => setHoverIndex(index)}
          onMouseLeave={() => setHoverIndex(null)}
          instanceRef={(ref) => (placeMarks[index] = ref)}
          key={index}
          geometry={getCoord(el.map)}
          properties={{
            balloonContentHeader: el.title,
            balloonContent: `<p style="margin: 5px 0;">${getAddress(
              el.map
            )}</p><p style="margin: 5px 0;">${
              el.phone
            }</p><p style="margin: 2.5px 0;">${el.schedule}</p>`,
            hintContent: `
        ${getAddress(el.map)}
        `,
          }}
          options={{
            preset: hoverIndex == index ? "islands#blueDotIcon" : "",
          }}
          modules={["geoObject.addon.hint", "geoObject.addon.balloon"]}
        />
      ))}
    </>
  );
};

const MapComp = ({ stores }) => {
  const [screen, setScreen] = useState(0);

  useEffect(() => {
    setScreen(window.innerWidth);
    if (map) {
      console.log("wow");
      map.setCenter([57.151876, 65.55189]);
    }
  }, []);

  return (
    <YMaps>
      <Map
        instanceRef={(ref) => (map = ref)}
        width={"100%"}
        height={screen < 1220 ? "80vh" : 800}
        state={{
          center:
            stores.length > 0 ? getCoord(stores[0].map) : [57.151876, 65.55189],
          zoom: 11,
        }}
      >
        <Marks stores={stores} />
      </Map>
    </YMaps>
  );
};

const StoreComponent = () => {
  const stores = useStoreState((state) => state.cityIp.storesShow);
  const privilege = useStoreState((state) => state.cityIp.privilege);
  const address = useStoreState((state) => state.cityIp.address);
  const optica = useStoreState((state) => state.cityIp.optica);
  const city = useStoreState((state) => state.cityIp.city);
  const setPrivilege = useStoreActions(
    (actions) => actions.cityIp.setPrivilege
  );
  const setAddress = useStoreActions((actions) => actions.cityIp.setAddress);
  const setOptica = useStoreActions((actions) => actions.cityIp.setOptica);
  const setShowPopup = useStoreActions(
    (actions) => actions.cityIp.setShowPopup
  );
  const [mapOrList, setMapOrList] = useState(true);

  return (
    <div className={mainClass}>
      <div className={mainClass + "-navLine"}></div>
      <div className={mainClass + "-container container"}>
        <div className={mainClass + "-main"}>
          <div className={mainClass + "-header"}>Аптечная сеть</div>
          <div className={mainClass + "-mapContainer"}>
            <div className={mainClass + "-info"}>
              <div className={mainClass + "-address"}>
                Адреса аптек в г.
                <span onClick={() => setShowPopup(true)}>{city}</span>
              </div>
              <div className={mainClass + "-checkboxes"}>
                <Checkbox
                  title={"Льготный отпуск"}
                  value={privilege}
                  handleChange={setPrivilege}
                />
                <Checkbox
                  title={"Оптика"}
                  value={optica}
                  handleChange={setOptica}
                />
              </div>
              <div className={mainClass + "-inputContainer"}>
                <input
                  type="text"
                  name="citySearch"
                  value={address}
                  onChange={(ev) => setAddress(ev.target.value)}
                ></input>
                <label htmlFor="citySearch" className="labelForInput">
                  <span className="material-icons searchIcon">search</span>
                  Поиск по улице
                </label>
              </div>
              <div className={mainClass + "-btnsChoose"}>
                <div
                  className={`left ${mapOrList ? "activeMap" : ""}`}
                  onClick={() => setMapOrList(true)}
                >
                  <span className="material-icons">map</span>Картой
                </div>
                <div
                  className={`right ${!mapOrList ? "activeMap" : ""}`}
                  onClick={() => setMapOrList(false)}
                >
                  <span className="material-icons">list</span>Списком
                </div>
              </div>
              <div
                className={`${mainClass}-cardsContainer ${
                  mapOrList && "hideMap"
                }`}
              >
                {stores.map((el, index) => (
                  <Card key={index} elem={el} index={index} />
                ))}
              </div>
            </div>
            <div className={`${mainClass}-map ${!mapOrList && "hideMap"}`}>
              <MapComp stores={stores} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

StoreComponent.getInitialProps = async (props) => {
  if (props.isServer) {
    await props.store.dispatch.cityIp.getStores();
  } else {
    const store = require("../../client");
    if (store.default.getState().cityIp.stores.length < 1) {
      await store.default.dispatch.cityIp.getStores();
    }
  }
  return { whatever: "stuff" };
};

export default StoreComponent;
